<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
        <v-card class="rounded-lg" elevation="12">
            <loading v-if="isLoading" />

            <v-toolbar color="primary" dark flat>
                <v-icon left>mdi-account-edit</v-icon>
                <v-toolbar-title class="font-weight-bold">Editar Dados do Estudante</v-toolbar-title>
                <v-spacer />
            </v-toolbar>

            <v-card-text class="pa-6">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="studentData.nome" label="*Nome completo" outlined
                                prepend-icon="mdi-account" clearable />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="studentData.bi" label="*Número do Documento" outlined
                                prepend-icon="mdi-card-account-details" clearable />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu ref="menubi" v-model="menubi" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="studentData.dataemissaobi" label="*Data de emissão do BI"
                                        prepend-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker ref="picker" v-model="datebi"
                                    :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" @change="saveDatebi"
                                    color="primary" locale="pt" />
                            </v-menu>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4">
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="studentData.datanascimento" label="*Data de nascimento"
                                        prepend-icon="mdi-cake-variant" readonly outlined v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker ref="picker" v-model="date" :max="new Date().toISOString().substr(0, 10)"
                                    min="1950-01-01" @change="saveDate" color="primary" locale="pt" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="studentData.nomedopai" label="Nome do pai" outlined
                                prepend-icon="mdi-human-male-boy" clearable />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="studentData.nomedamae" label="Nome da mãe" outlined
                                prepend-icon="mdi-human-female-boy" clearable />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4">
                            <v-combobox v-model="provinciaSelected" :items="provinciasAll" item-value="idProvicia"
                                item-text="descricao" @change="loadMunicipioComb" return-object label="*Natural de:"
                                outlined prepend-icon="mdi-map-marker" :rules="ruleRequired" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-combobox v-model="municipioSelected" :items="municipiosFiltered" item-value="idMunicipio"
                                item-text="descricao" return-object label="*Município" outlined prepend-icon="mdi-city"
                                :rules="ruleRequired" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-combobox v-model="sexSelected" :rules="ruleRequired" item-value="idSexo"
                                item-text="descricao" :items="genderDropdown" label="*Sexo" outlined
                                prepend-icon="mdi-gender-male-female" />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="studentData.email" label="Email" outlined prepend-icon="mdi-email"
                                clearable />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="studentData.telefone" label="Telefone" outlined
                                prepend-icon="mdi-phone" clearable />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions class="pa-6 pt-0">
                <v-spacer />
                <v-btn color="grey darken-1" large outlined @click="closeEditCard(false)" class="px-6 rounded-pill">
                    <v-icon left>mdi-close-circle</v-icon>
                    Fechar
                </v-btn>
                <v-btn color="primary" large @click="updateStudentData" class="px-6 rounded-pill" depressed>
                    <v-icon left>mdi-content-save-check</v-icon>
                    Salvar Alterações
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from '../../../../plugins/axios'
import Swal from 'sweetalert2';

export default {
    props: {
        estudante: Object
    },
    components: {
        loading: () => import("../../../../components/loading.vue")
    },
    data() {
        return {
            dialog: true,
            studentData: {
                nome: "",
                bi: "",
                dataemissaobi: "",
                datanascimento: "",
                nomedopai: "",
                nomedamae: "",
                email: "",
                telefone: ""
            },
            date: null,
            datebi: null,
            menu: false,
            menubi: false,
            ruleRequired: [value => !!value || 'Campo obrigatório'],
            provinciasAll: [],
            provinciaSelected: null,
            municipioSelected: null,
            municipiosFiltered: [],
            municipiosAll: [],
            isLoading: false,
            genderDropdown: [
                { idSexo: 'M', descricao: 'Masculino' },
                { idSexo: 'F', descricao: 'Femenino' }
            ],
            sexSelected: null
        };
    },

    async created() {
        await this.initializeProvincias();
        await this.initializeMunicipiosAll();
        await this.getStudentData();
    },

    methods: {
        async initializeProvincias() {
            this.isLoading = true;
            try {
                this.provinciasAll = await axios.get('/provinciaFindAll').then(res => res.data)
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    html: '<p class="body-1">Erro ao carregar as províncias.</p>',
                    icon: 'error',
                    confirmButtonColor: '#1976D2'
                })
            } finally {
                this.isLoading = false;
            }
        },

        async initializeMunicipiosAll() {
            this.isLoading = true;
            try {
                this.municipiosAll = await axios.get('/municipioFindAll').then(res => res.data)
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    html: '<p class="body-1">Erro ao carregar os municipios.</p>',
                    icon: 'error',
                    confirmButtonColor: '#1976D2'
                })
            } finally {
                this.isLoading = false;
            }
        },

        async getStudentData() {
            this.isLoading = true;
            try {
                this.studentData = await axios.get(`/getStudentData/${this.estudante.idMatricula}`).then(res => res.data[0])

                // Filtering the provincia based on the student's current idProvincia
                this.provinciaSelected = this.provinciasAll.filter((p) => p.idProvincia == this.studentData.ResidenteEm)[0];
                // Filtering the municipio based on the student's current idMunicipio
                this.municipioSelected = this.municipiosAll.filter((m) => m.idMunicipio == this.studentData.idMunicipio)[0];
                // Filtering the gender based on the student's current idSexo
                this.sexSelected = this.genderDropdown.filter((s) => s.idSexo == this.studentData.sexo)[0];
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    html: '<p class="body-1">Erro ao carregar os dados do estudante.</p>',
                    icon: 'error',
                    confirmButtonColor: '#1976D2'
                })
            } finally {
                this.isLoading = false;
            }
        },

        loadMunicipioComb(provincia) {
            // Checking if the current municipio belongs to the current provincia
            // If yes, then there's no need to "clear" the municipio
            if (provincia.idProvincia != this.municipioSelected.idProvincia) this.municipioSelected = null;
            this.municipiosFiltered = this.municipiosAll.filter((municipio) => municipio.idProvincia == provincia.idProvincia);
        },

        saveDate(val) {
            this.studentData.datanascimento = val;
            this.menu = false;
        },
        saveDatebi(val) {
            this.studentData.dataemissaobi = val;
            this.menubi = false;
        },
        validateForm() {
            this.isLoading = true;
            try {
                const { studentData, provinciaSelected, municipioSelected } = this;
                // Verifique se os campos obrigatórios estão preenchidos
                if (
                    !studentData.nome ||
                    !studentData.bi ||
                    !studentData.dataemissaobi ||
                    !studentData.datanascimento ||
                    provinciaSelected == null ||
                    municipioSelected == null
                ) {
                    return true;
                } else {
                    return false;
                }

            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    html: '<p class="body-1">Erro durante a validação do formulário.</p>',
                    icon: 'error',
                    confirmButtonColor: '#1976D2'
                })
            } finally {
                this.isLoading = false;
            }
        },

        closeEditCard(bool) {
            this.studentData = {
                nome: "",
                bi: "",
                dataemissaobi: "",
                datanascimento: "",
                nomedopai: "",
                nomedamae: "",
                email: "",
                telefone: ""

            };
            this.cardEditar = false;
            this.provinciaSelected = null;
            this.municipioSelected = null;
            this.$emit('cancel', bool)
        },

        async updateStudentData() {
            if (this.validateForm()) {
                Swal.fire({
                    title: 'Atenção',
                    html: '<p class="body-1">Os campos nome, B.I, Data de emissão do B.I, data de nascimento, Naturalidade e municípios são obrigatórios</p>',
                    icon: 'warning',
                    confirmButtonColor: '#1976D2'
                });
            } else {
                let params = {
                    nome: this.studentData.nome,
                    bi: this.studentData.bi,
                    dataBi: this.studentData.dataemissaobi,
                    dataNascimento: this.studentData.datanascimento,
                    pai: this.studentData.nomedopai,
                    mae: this.studentData.nomedamae,
                    provincia: this.provinciaSelected.descricao,
                    idProvincia: this.provinciaSelected.idProvincia,
                    municipio: this.municipioSelected.descricao,
                    idMunicipio: this.municipioSelected.idMunicipio,
                    sexo: this.sexSelected.idSexo,
                    telefone: this.studentData.telefone,
                    matricula: this.estudante.idMatricula,
                    email: this.studentData.email
                }
                Swal.fire({
                    title: 'Finalizar edição',
                    html: ` 
                        <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Confirme os dados antes de finalizar a operação.</p>
                        <div style="width: 90%; margin: 10 auto;">
                            <div style="display: grid; grid-template-columns: 150px auto;">
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.nome}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Doc.</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.bi}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data Doc.:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.dataBi}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data de nascimento:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.dataNascimento}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Filho de:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.pai}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>E de:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.mae}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Naturalidade:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.provincia}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Municipio:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.municipio}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Sexo:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.sexo}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Contacto:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.telefone}</div>
                            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Email:</strong></div>
                            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.email}</div>
                            </div>
                        </div>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: 'green',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Finalizar',
                    reverseButtons: true,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.isLoading = true;
                        try {
                            let result = await axios.post('/editarDadosEstudante', params).then(res => res.data);
                            if (result.affectedRows >= 1) {
                                Swal.fire('Sucesso', '<p>Dados alterados com sucesso!</p>', 'success')
                                this.closeEditCard(true);
                            } else if (result.messages == 'Duplicate') {
                                Swal.fire('Informação', '<p>Número do Bilhete ou Processo já registrado.</p>', 'warning')
                            } else {
                                Swal.fire('Error', '<p>Erro ao actualizar os dados do estudante.</p>', 'error')
                            }
                        } catch (error) {
                            Swal.fire('Error', '<p>Erro ao actualizar os dados do estudante.</p>', 'error')
                        } finally {
                            this.isLoading = false;
                        }
                    }
                })
            }
        },
    }
};
</script>

<style scoped>
.v-card {
    background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
}

.v-text-field--outlined>>>fieldset {
    border-color: rgba(0, 0, 0, 0.1);
}

.v-toolbar {
    border-radius: 8px 8px 0 0 !important;
}

.v-data-table>>>tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, 0.02);
}
</style>